<dx-popup
    #editVendorForProposalPopup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="35%"
    title="Edit Vendor For Proposal"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <dx-box width="100%" height="100%" direction="col">
        <dxi-item [ratio]="1">
            <div *dxTemplate>
                <dx-form width="100%" height="100%" labelLocation="top" [colCount]="1">
                    <dxi-item>
                        <dxo-label text="Estimated Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [showClearButton]="true"
                                [showSpinButtons]="false"
                                [min]="0"
                                [format]="currencyFormat"
                                [(value)]="estimatedAmount"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label
                            text="Click the Upload button below to upload estimate received from the vendor"
                        ></dxo-label>
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Upload"
                                [icon]="iconUpload"
                                (onClick)="onUploadClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-form>
            </div>
        </dxi-item>
        <dxi-item baseSize="auto">
            <div *dxTemplate class="toolbar-container">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onPopupClose()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </div>
        </dxi-item>
    </dx-box>
</dx-popup>

<app-manage-quotes
    *ngIf="showProposalQuoteManager"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [customerId]="customerId"
    [workOrderProposalId]="workOrderProposalId"
    (onClose)="onQuoteManagerClose()"
></app-manage-quotes>
